module.exports = __webpack_public_path__ + "static/media/D-DIN-Bold.c352e7b6.otf";